import AboutUs from '../../modules/AboutUsPage/AboutUs';

function AboutLayout() {
  return (
    <div>
      <AboutUs />
    </div>
  );
}

export default AboutLayout;

